import apiSettings from '@/services/api.settings'
import {
  findCategoriesServicesBreakdown,
  findInvoiceCategoriesFromBreakdown
} from "@/common/helpers/findCategoriesServicesBreakdown";

const state = {
  client: {},
  participants: [],
  calculationResult: [],
  categoriesServicesBreakdown: [],
  isLoadingClient: false,

  allEmailTemplates: [],
  isLoadingAllEmailTemplates: false,

  isLoadingUpdateEmailTemplate: false,

  isLoadingCreateEmailTemplate: false,

  currentEmailTemplate: {},
  isLoadingCurrentEmailTemplate: false,

  isLoadingDeleteEmailTemplate: false,

  isLoadingFollowUp: false,
  messagesFollowUp: {
    code: null,
    text: ''
  },
  isSendBalloon: false,
  messageBalloon: {
    code: null,
    text: ''
  },

}

export const mutationTypes = {
  clientStart: '[settings] Client start',
  clientSuccess: '[settings] Client success',
  clientFailure: '[settings] Client failure',

  getEmailTemplatesStart: '[settings] Get email templates start',
  getEmailTemplatesSuccess: '[settings] Get email templates success',
  getEmailTemplatesFailure: '[settings] Get email templates failure',

  updateEmailTemplateStart: '[settings] Update email template start',
  updateEmailTemplateSuccess: '[settings] Update email template success',
  updateEmailTemplateFailure: '[settings] Update email template failure',

  createEmailTemplateStart: '[settings] Create email template start',
  createEmailTemplateSuccess: '[settings] Create email template success',
  createEmailTemplateFailure: '[settings] Create email template failure',

  getCurrentEmailTemplateStart: '[settings] Get current email template start',
  getCurrentEmailTemplateSuccess: '[settings] Get current email template success',
  getCurrentEmailTemplateFailure: '[settings] Get current email template failure',

  deleteCurrentEmailTemplateStart: '[settings] Delete current email template start',
  deleteCurrentEmailTemplateSuccess: '[settings] Delete current email template success',
  deleteCurrentEmailTemplateFailure: '[settings] Delete current email template failure',

  followUpStart: '[settings] Follow up start',
  followUpSuccess: '[settings] Follow up success',
  followUpFailure: '[settings] Follow up failure',

  sendBalloonStart: '[settings] Send balloon start',
  sendBalloonSuccess: '[settings] Send balloon success',
  sendBalloonFailure: '[settings] Send balloon failure',

  sendPortableToiletStart: '[settings] Send portable toilet start',
  sendPortableToiletSuccess: '[settings] Send portable toilet success',
  sendPortableToiletFailure: '[settings] Send portable toilet failure',

}

export const actionTypes = {
  getClient: '[settings] Get Client invoices',
  getEmailTemplates: '[settings] Get email templates',
  updateEmailTemplate: '[settings] Update email template',
  createEmailTemplate: '[settings] Create email template',
  getCurrentEmailTemplate: '[settings] Get current email template',
  deleteCurrentEmailTemplate: '[settings] Delete current email template',
  followUp: '[settings] Follow up',
  sendBalloonOptions: '[settings] Send balloon options',
  sendPortableToiletOptions: '[settings] Send portable toilet options'
}

export const getterTypes = {
  client: '[settings] Client',
  participants: '[settings] participants',
  calculationResult: '[settings] Calculation Result',
  categoriesServicesBreakdown: '[settings] Categories services breakdown',
  invoiceServices: '[settings] Invoice Services',
  isLoadingClient: '[settings] Is loading client',
  allEmailTemplates: '[settings] All email templates',
  isLoadingAllEmailTemplates: '[settings] Is loading all email templates',
  isLoadingUpdateEmailTemplate: '[settings] Is loading update email template',
  isLoadingCreateEmailTemplate: '[settings] Is loading create email template',
  currentEmailTemplate: '[settings] Current email template',
  isLoadingCurrentEmailTemplate: '[settings] Is loading current email template',
  isLoadingDeleteEmailTemplate: '[settings] Is loading delete email template',
  isLoadingFollowUp: '[settings] Is loading follow up',
  messagesFollowUp: '[settings] Messages follow up',
  isSendBalloon: '[settings] Is send balloon',
  messageBalloon: '[settings] Message balloon'
}

const getters = {
  [getterTypes.client]: (state) => {
    return state.client
  },
  [getterTypes.participants]: (state) => {
    return state.participants
  },
  [getterTypes.calculationResult]: (state) => {
    return state.calculationResult
  },
  [getterTypes.isLoadingClient]: (state) => {
    return state.isLoadingClient
  },
  [getterTypes.categoriesServicesBreakdown]: (state) => {
    return state.categoriesServicesBreakdown
  },
  [getterTypes.invoiceServices]: (state) => {
    return state.invoiceServices
  },
  [getterTypes.allEmailTemplates]: (state) => {
    return state.allEmailTemplates
  },
  [getterTypes.isLoadingAllEmailTemplates]: (state) => {
    return state.isLoadingAllEmailTemplates
  },
  [getterTypes.isLoadingUpdateEmailTemplate]: (state) => {
    return state.isLoadingUpdateEmailTemplate
  },
  [getterTypes.isLoadingCreateEmailTemplate]: (state) => {
    return state.isLoadingCreateEmailTemplate
  },
  [getterTypes.currentEmailTemplate]: (state) => {
    return state.currentEmailTemplate
  },
  [getterTypes.isLoadingCurrentEmailTemplate]: (state) => {
    return state.isLoadingCurrentEmailTemplate
  },
  [getterTypes.isLoadingDeleteEmailTemplate]: (state) => {
    return state.isLoadingDeleteEmailTemplate
  },
  [getterTypes.messagesFollowUp]: (state) => {
    return state.messagesFollowUp
  },
  [getterTypes.isLoadingFollowUp]: (state) => {
    return state.isLoadingFollowUp
  },
  [getterTypes.messageBalloon]: (state) => {
    return state.messageBalloon
  },
  [getterTypes.isSendBalloon]: (state) => {
    return state.isSendBalloon
  }
}

const mutations = {
  [mutationTypes.clientStart](state) {
    state.isLoadingClient = true
  },
  [mutationTypes.clientSuccess](state, payload) {
    state.isLoadingClient = false
    state.client = payload
    state.participants = payload.program.frontendMeta.participants
    state.calculationResult = payload.calculationResult

    // console.log('state.client', state.client)
    // console.log('state.participants', state.participants)
    // console.log('state.calculationResult', state.calculationResult)

    state.categoriesServicesBreakdown = findCategoriesServicesBreakdown()
    state.invoiceServices = findInvoiceCategoriesFromBreakdown(state.calculationResult.breakdownCost)
    // console.log(
    //   ' state.categoriesServicesBreakdown',
    //   state.categoriesServicesBreakdown
    // )
  },
  [mutationTypes.clientFailure](state) {
    state.isLoadingClient = false
  },
  [mutationTypes.getEmailTemplatesStart](state) {
    state.isLoadingAllEmailTemplates = true
  },
  [mutationTypes.getEmailTemplatesSuccess](state, data) {
    state.isLoadingAllEmailTemplates = false
    state.allEmailTemplates = data.map(e => {
      let newEmailTemplates = Object.assign({menu: false}, e)
      return newEmailTemplates
    })
  },
  [mutationTypes.getEmailTemplatesFailure](state) {
    state.isLoadingAllEmailTemplates = false
  },
  [mutationTypes.updateEmailTemplateStart](state) {
    state.isLoadingUpdateEmailTemplate = true
  },
  [mutationTypes.updateEmailTemplateSuccess](state) {
    state.isLoadingUpdateEmailTemplate = false
  },
  [mutationTypes.updateEmailTemplateFailure](state) {
    state.isLoadingUpdateEmailTemplate = false
  },
  [mutationTypes.createEmailTemplateStart](state) {
    state.isLoadingCreateEmailTemplate = true
  },
  [mutationTypes.createEmailTemplateSuccess](state, data) {
    state.isLoadingCreateEmailTemplate = false
    // console.log('>> CREATE email template DATA: ', data)
  },
  [mutationTypes.createEmailTemplateFailure](state) {
    state.isLoadingCreateEmailTemplate = false
  },
  [mutationTypes.getCurrentEmailTemplateStart](state) {
    state.isLoadingCurrentEmailTemplate = true
  },
  [mutationTypes.getCurrentEmailTemplateSuccess](state, data) {
    state.isLoadingCurrentEmailTemplate = false
    state.currentEmailTemplate = data
  },
  [mutationTypes.getCurrentEmailTemplateFailure](state) {
    state.isLoadingCurrentEmailTemplate = false
  },
  [mutationTypes.deleteCurrentEmailTemplateStart](state) {
    state.isLoadingDeleteEmailTemplate = true
  },
  [mutationTypes.deleteCurrentEmailTemplateSuccess](state) {
    state.isLoadingDeleteEmailTemplate = false
  },
  [mutationTypes.deleteCurrentEmailTemplateFailure](state) {
    state.isLoadingDeleteEmailTemplate = false
  },
  [mutationTypes.followUpStart] (state) {
    state.isLoadingFollowUp = true
    state.messagesFollowUp.code = null
    state.messagesFollowUp.text = ''
  },
  [mutationTypes.followUpSuccess](state) {
    state.isLoadingFollowUp = false
    state.messagesFollowUp.code = 200
    state.messagesFollowUp.text = 'Email has been sent, thank you!'
  },
  [mutationTypes.followUpFailure](state, error) {
    state.isLoadingFollowUp = false
    state.messagesFollowUp.code = error.status
    state.messagesFollowUp.text = error.data.message
  },
  [mutationTypes.sendBalloonStart] (state) {
    state.isSendBalloon = true
    state.messageBalloon.code = null
    state.messageBalloon.text = ''
  },
  [mutationTypes.sendBalloonSuccess](state) {
    state.isSendBalloon = false
    state.messageBalloon.code = 200
    state.messageBalloon.text = 'Balloon has been sent, thank you!'
  },
  [mutationTypes.sendBalloonFailure](state, error) {
    state.isSendBalloon = false
    state.messageBalloon.code = error.status
    state.messageBalloon.text = error.data.message
  }
}

const actions = {
  [actionTypes.getClient](context, payload) {
    return new Promise((resolve) => {
      context.commit(mutationTypes.clientStart)
      apiSettings
        .getClient(payload)
        .then((response) => {
          context.commit(mutationTypes.clientSuccess, response.data)
          resolve(response)
        })
        .catch((result) => {
          context.commit(mutationTypes.clientFailure, result.response.data)
        })
    })
  },
  [actionTypes.getEmailTemplates](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getEmailTemplatesStart)
      apiSettings
          .getEmailTemplates(payload)
          .then(response => {
            context.commit(mutationTypes.getEmailTemplatesSuccess, response.data)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.getCurrentEmailTemplateFailure)
            reject(error)
          })
    })
  },
  [actionTypes.updateEmailTemplate](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.updateEmailTemplateStart)
      apiSettings
          .updateEmailTemplate(payload)
          .then(response => {
            context.commit(mutationTypes.updateEmailTemplateSuccess, response.data)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.updateEmailTemplateFailure)
            reject(error)
          })
    })
  },
  [actionTypes.createEmailTemplate](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.createEmailTemplateStart)
      apiSettings
          .createEmailTemplate(payload)
          .then(response => {
            context.commit(mutationTypes.createEmailTemplateSuccess, response.data)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.createEmailTemplateFailure)
            reject(error)
          })
    })
  },
  [actionTypes.getCurrentEmailTemplate](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.getCurrentEmailTemplateStart)
      apiSettings
          .getCurrentEmailTemplate(payload)
          .then(response => {
            context.commit(mutationTypes.getCurrentEmailTemplateSuccess, response.data)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.getCurrentEmailTemplateFailure)
            reject(error)
          })
    })
  },
  [actionTypes.deleteCurrentEmailTemplate](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.deleteCurrentEmailTemplateStart)
      apiSettings
          .deleteCurrentEmailTemplate(payload)
          .then(response => {
            context.commit(mutationTypes.deleteCurrentEmailTemplateSuccess, response.data)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.deleteCurrentEmailTemplateFailure)
            reject(error)
          })
    })
  },
  [actionTypes.followUp](context, payload) {
    return new Promise((resolve) => {
      context.commit(mutationTypes.followUpStart)
      apiSettings
          .followUp(payload)
          .then(response => {
            context.commit(mutationTypes.followUpSuccess)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.followUpFailure, error.response)
          })
    })
  },
  [actionTypes.sendBalloonOptions](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.sendBalloonStart)
      apiSettings
          .sendBalloon(payload)
          .then(response => {
            context.commit(mutationTypes.sendBalloonSuccess)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.sendBalloonFailure)
            reject(error)
          })
    })
  },
  [actionTypes.sendPortableToiletOptions](context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(mutationTypes.sendPortableToiletStart)
      apiSettings
          .sendPortableToilet(payload)
          .then(response => {
            context.commit(mutationTypes.sendPortableToiletSuccess)
            resolve(response)
          })
          .catch(error => {
            context.commit(mutationTypes.sendPortableToiletFailure)
            reject(error)
          })
    })
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
}
